import requestv2 from '@/api/requestv2'

const getBalance = function (number) {
  return requestv2({
    url: `/guest/balance/${number}`,
    method: 'get'
  })
}

const getBalanceTag = function (number) {
  return requestv2({
    url: `/guest/balance/${number}?is_tag=true`,
    method: 'get'
  })
}

export default {
  getBalance,
  getBalanceTag
}
